import { AnyAction } from 'redux';
import { answersPageActionTypes } from '@actions/actionTypes/answersPage';
import { answersPageInitialState } from './initialState/answersPage';

export const answersPageReducer = (state = answersPageInitialState, action: AnyAction) => {
  switch (action.type) {
    case answersPageActionTypes.SET_IS_OPEN_MARK_AS_SENT_MODAL: {
      return { ...state, isOpenMarkAsSentModal: action.payload };
    }
    case answersPageActionTypes.SET_IS_OPEN_ANSWERS_DELETE_MODAL: {
      return { ...state, isOpenAnswersDeleteModal: action.payload };
    }
    case answersPageActionTypes.SET_ANSWERS_PAGE_NUMBER: {
      return { ...state, pageNumber: action.payload };
    }
    case answersPageActionTypes.SET_ANSWERS_FILTERS: {
      return { ...state, filters: action.payload };
    }
    case answersPageActionTypes.RESET_ANSWERS_FILTERS: {
      return { ...state, filters: answersPageInitialState.filters };
    }
    default: {
      return state;
    }
  }
};
